export default __webpack_public_path__ + "static/media/16.7583f28e.svg";